import Annotation from "./annotation";
import { setLineStyle, defaultColorSettings, hasCustomPixelColorSettings, setMinimalSize, drawShadedImage, applyPixelShadingRules } from "../canvasUtils";

export default class Periscope extends Annotation {
  constructor(){
    super();

    this.showBackground = false;
    this.x = 0;
    this.y = 0;
    this.radius = 100;

    this.color = "white";
    this.lineWidth = 1;

    this.img = null;
    this.imgSize = null;

    this.processingCanvas = document.createElement("canvas");
    this.colorSettings = defaultColorSettings();
    this.useCanvas = false;
  }

  get processedImg(){
    return this.useCanvas ? this.processingCanvas : this.img;
  }

  draw(ctx){
    if (!this.img || !this.imgSize) return;
    this.drawPeriscopeBorder(ctx);
    if (this.showBackground) this.drawClippedImg(ctx);
  }

  drawClippedImg(ctx){
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, true);
    ctx.clip();
    ctx.drawImage(this.processedImg, 0, 0, this.imgSize.w, this.imgSize.h);
  }

  drawPeriscopeBorder(ctx){
    ctx.beginPath();
    setLineStyle(ctx, this);
    ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, true);
    ctx.stroke();
    ctx.closePath();
  }

  click(){
    this.showBackground = !this.showBackground;
    this.signalReady();
  }

  mousemove(x, y){
    this.x = x;
    this.y = y;
    this.signalReady();
  }

  updateImg(img){
    if (img === this.img) return;
    this.img = img;
    this.recalculateImage();
    this.signalReady();
  }

  updateImgSize(imgSize){
    this.imgSize = imgSize;
    this.signalReady();
  }

  updateRadius(radius){
    this.radius = radius;
    this.signalReady();
  }

  updateColorSettings(settings){
    if (settings.grayscaleMode === this.colorSettings.grayscaleMode) return;
    this.colorSettings = settings;
    this.recalculateImage();
    this.signalReady();
  }

  recalculateImage() {
    if (!hasCustomPixelColorSettings(this.colorSettings)){
      this.useCanvas = false;
      return;
    }

    setMinimalSize(this.processingCanvas, this.img, this.img);
    drawShadedImage(this.img, this.processingCanvas, applyPixelShadingRules, this.colorSettings);
    this.useCanvas = true;
  }
}